export enum ApprovalStatus {
  RESERVED = "RESERVED",
  QUEUEING = "QUEUEING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  WAITING = "WAITING",
  ALL = "ALL"
}
